import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

export function useDefaultDisclaimerSlideTitle() {
  const { displayName } = useTenantDetailsContext();
  return `${displayName} legal disclaimer`;
}
